import { LinkNode } from "@lexical/link";
import { sanitizeUrl } from "../../utils/index.js";
const isPatched = Symbol('safeLinkSanitizerPatched');
const installSafeLinkSanitizer = ()=>{
    const proto = LinkNode.prototype;
    if (proto[isPatched]) return;
    proto.sanitizeUrl = sanitizeUrl;
    proto[isPatched] = true;
};
installSafeLinkSanitizer();
export { installSafeLinkSanitizer };
